export default __webpack_public_path__ + "static/media/playering4.a594b2f2.png";